import { SaaSProduct, ServiceItem, CaseStudy, TeamMember, RedirectRule } from '../types';

export const BRAND_CONFIG = {
  name: 'AMGOC US LLC',
  tagline: 'AI-driven innovation for business success.',
  quote: 'From Concept to Scale—We Build the Future of Business',
  colors: {
    obsidian: '#031121',
    royalBlue: '#3B82F6',
    pureWhite: '#FFFFFF',
    navyInk: '#1E293B',
    slateMist: '#94A3B8',
  },
  offices: {
    usa: {
      country: 'USA',
      title: 'USA Headquarters',
      address: '14205 Heritage Crossing LN, Centreville, VA',
      phone: '+1 (571) 554-9508',
      email: 'info@amgoc.us',
      hours: '09:00 AM - 06:00 PM EST',
      flag: '🇺🇸'
    },
    pakistan: {
      country: 'Pakistan',
      title: 'Pakistan Innovation Center',
      address: '17 F.C.C, Syed Maratib Ali Road, Gulberg IV, Lahore, Pakistan.',
      phone: '+92 42 111 165 165',
      email: 'pk@amgoc.us',
      hours: '09:00 AM - 06:00 PM PKT',
      flag: '🇵🇰'
    }
  },
  stats: [
    { label: 'SaaS Products Ready', value: '10', detail: 'Deploy Today' },
    { label: 'Projects Delivered', value: '50+', detail: 'Global Enterprise Scale' },
    { label: 'International Clients', value: '15+', detail: 'USA, EU, ME & Asia' },
    { label: 'AI Agents Deployed', value: '100+', detail: 'Autonomous Execution' },
    { label: 'Automation Workflows', value: '500+', detail: 'CRM & Lead Gen' },
    { label: 'Client Retention Rate', value: '98%', detail: 'Long-term Partnerships' }
  ]
};

export const ASSETS = {
  logo: 'https://storage.googleapis.com/amgoc-us-static-assets/images/logos/amgocusus.png',
  videos: {
    heroLoopWebm: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/videos_digital-canvas-loop.webm',
    heroLoopMp4: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/digital-canvas-loop.mp4',
    meetingSense: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/meeting-sense-hero-vid.webm',
    inventoryAi: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/inventory-ai-vid.webm',
    aqiVid: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/aqi-vid.webm',
    aiNeural: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/services/ai-neural-network.mp4',
    codeFlow: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/services/code-flow-abstract.mp4',
    criticalInfra: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/services/critical-infra-abstract.mp4',
    globalTalent: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/services/global-talent-network.mp4',
    geospatial: 'https://storage.googleapis.com/amgoc-us-static-assets/videos/services/geospatial-abstract.mp4',
    ytEmbed: 'https://www.youtube.com/embed/5Ei18DjQuJQ'
  },
  images: {
    workspace: 'https://storage.googleapis.com/amgoc-us-static-assets/images/banners/collaborative-workspace-v2.webp',
    mapPlaceholder: 'https://storage.googleapis.com/amgoc-us-static-assets/images/contact/map-placeholder-v2.webp',
    dataAnalytics: 'https://storage.googleapis.com/amgoc-us-static-assets/images/insights/data-analytics-v2.webp',
    aiMlHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/ai-ml-hero.webp',
    realEstateHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/apps/real-estate-hero-v2.webp',
    datingAppHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/apps/dating-app-hero-v2.webp',
    taxiAppHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/apps/taxi-app-hero-v2.webp',
    smmHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/social/smm-hero-v2.webp',
    seoHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/social/seo-hero-v2.webp',
    chatAppHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/social/chat-app-hero-v2.webp',
    googleAdsHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/social/google-ads-hero-v2.webp',
    virtualAssistant: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/ai/virtual-assistant.webp',
    nlpDev: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/ai/nlp-development.webp',
    apiIntegration: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/ai/api-integration.webp',
    analytics: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/ai/analytics.webp',
    inventory1: 'https://storage.googleapis.com/amgoc-us-static-assets/images/solutions/inventory-ai-1.webp',
    inventory2: 'https://storage.googleapis.com/amgoc-us-static-assets/images/solutions/inventory-ai-2.webp',
    aqiHero: 'https://storage.googleapis.com/amgoc-us-static-assets/images/solutions/environmental-intelligence/aqi-hero-image.webp',
    aqiArchitecture: 'https://storage.googleapis.com/amgoc-us-static-assets/images/solutions/environmental-intelligence/aqi-system-architecture.webp',
    aqiDashboard: 'https://storage.googleapis.com/amgoc-us-static-assets/images/solutions/environmental-intelligence/aqi-dashboard.webp',
    foodAppShowcase: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/apps/food-app-showcase.webp',
    carWashShowcase: 'https://storage.googleapis.com/amgoc-us-static-assets/images/services/apps/car-wash-showcase-v2.webp',
    testimonialMichael: 'https://storage.googleapis.com/amgoc-us-static-assets/images/testimonials/michael-b-v2.webp',
    testimonialSarah: 'https://storage.googleapis.com/amgoc-us-static-assets/images/testimonials/sarah-l-v2.webp',
    teamRizwan: 'https://storage.googleapis.com/amgoc-us-static-assets/images/team/rizwanjaved.webp',
    teamMubbashar: 'https://storage.googleapis.com/amgoc-us-static-assets/images/team/mubbasharsaddique.webp',
    teamDrWaheed: 'https://storage.googleapis.com/amgoc-us-static-assets/images/team/dr-waheed.webp',
    teamUsman: 'https://storage.googleapis.com/amgoc-us-static-assets/images/team/usman.webp',
  }
};

export const SAAS_PRODUCTS: SaaSProduct[] = [
  {
    id: 'intelligraph',
    name: 'IntelliGraph',
    tagline: 'Enterprise Knowledge Graph platform powered by GraphRAG.',
    description: 'Ask questions in natural language, discover hidden insights across disparate enterprise document silos, and automate high-value compliance and research decisions without hallucinations.',
    icon: 'Network',
    badge: 'Flagship AI',
    keyFeatures: [
      'GraphRAG architecture connecting vector search with graph context',
      'Natural language query engine over structured and unstructured data',
      'Automatic entity-relationship discovery',
      'Role-based security & zero data leakage guarantees'
    ],
    useCases: [
      'Federal & State Legal Compliance Verification',
      'Enterprise Document Analysis & Risk Mining',
      'Knowledge Base Search for Healthcare & Engineering'
    ],
    heroImage: ASSETS.images.dataAnalytics
  },
  {
    id: 'conversaigent',
    name: 'Conversaigent',
    tagline: 'AI-Powered Contact Center Intelligence Platform.',
    description: 'Centralizes multi-channel customer communications across Voice, WhatsApp, Email, and Web Chat. Automates 100% Quality Assurance, live agent coaching, and outbound campaign creation.',
    icon: 'Headphones',
    badge: 'Enterprise CX',
    keyFeatures: [
      'Real-time automated call scoring & sentiment tracking',
      'Omnichannel routing across Voice, WhatsApp & Chat',
      'AI Agent Co-Pilot for live customer support reps',
      'Instant voice synthesis & custom speech fine-tuning'
    ],
    useCases: [
      'High-volume Customer Care Centers in US & PK',
      'Automated Outbound Collections & Lead Qualifying',
      'Multi-lingual Helpline Services'
    ],
    demoVideo: ASSETS.videos.aiNeural
  },
  {
    id: 'schoolflow360',
    name: 'SchoolFlow360',
    tagline: 'Complete Cloud-Based School & University Management System.',
    description: 'An all-in-one educational operating platform managing the student lifecycle from initial enquiry and online admission to grading, fee management, AI attendance, and graduation.',
    icon: 'GraduationCap',
    badge: 'EdTech SaaS',
    keyFeatures: [
      'Complete admissions & student lifecycle portal',
      'Fee management & automated online invoice collection',
      'AI-powered attendance & computer vision campus security',
      'Parent-Teacher portal with real-time gradebooks'
    ],
    useCases: [
      'K-12 Private & Charter School Networks',
      'Universities & Vocational Institutions in US & South Asia',
      'Multi-campus Educational Systems'
    ],
    heroImage: ASSETS.images.workspace
  },
  {
    id: 'eventflo360',
    name: 'EventFlo360',
    tagline: 'AI-Powered Event & Exhibition Management Platform.',
    description: 'Empowers event organizers with intelligent B2B buyer-supplier matchmaking, automated session ticketing, badge scanning, and real-time attendee crowd analytics.',
    icon: 'Calendar',
    badge: 'Event Tech',
    keyFeatures: [
      'AI Matchmaking engine pairing buyers with exhibitors',
      'Smart badge generation & contactless QR access',
      'Automated session summaries & video recording indexing',
      'Real-time exhibitor ROI & lead capture analytics'
    ],
    useCases: [
      'International Tech Expos & Trade Shows',
      'Corporate Conferences in North America & Middle East',
      'Hybrid & Virtual Summits'
    ],
    heroImage: ASSETS.images.workspace
  },
  {
    id: 'reaicoach',
    name: 'reaicoach.com',
    tagline: 'AI Sales Coaching Platform Boosting Conversions by 22%.',
    description: 'Automatically transcribes and evaluates 100% of sales calls, identifying objection handling gaps, talk-to-listen ratios, and delivering tailored daily micro-coaching modules.',
    icon: 'TrendingUp',
    badge: 'Sales Acceleration',
    keyFeatures: [
      '100% Call Coverage with speech-to-text accuracy',
      'Objection handling & competitor mention detection',
      'Custom playbook scoring & conversion attribution',
      'Automated CRM sync with Zoom, Teams, and Dialpad'
    ],
    useCases: [
      'B2B SaaS Sales Teams in USA & Europe',
      'Insurance & Real Estate Advisory Agents',
      'Outbound SDR Call Centers'
    ],
    heroImage: ASSETS.images.dataAnalytics
  },
  {
    id: 'meetingsense',
    name: 'Meeting Sense',
    tagline: 'Smart Meeting Manager with Facial & Voice AI Action Items.',
    description: 'Transforms meetings into structured, searchable organizational knowledge with multi-speaker voice attribution, facial verification, and automated Jira/Trello action items.',
    icon: 'Video',
    badge: 'Productivity AI',
    keyFeatures: [
      'Multi-speaker voice separation & facial recognition',
      'Automated executive summaries & decision logs',
      'One-click sync to Slack, Google Workspace, and Teams',
      'Sub-second query engine across historical transcripts'
    ],
    useCases: [
      'Executive Leadership & Board Meetings',
      'Agile Software Engineering Daily Standups',
      'Academic Faculty & Governance Committees'
    ],
    demoVideo: ASSETS.videos.meetingSense
  },
  {
    id: 'sellagent',
    name: 'sellagent.ai',
    tagline: 'Autonomous AI Sales Agent Qualifying Leads 24/7.',
    description: 'An autonomous AI SDR that engages web visitors, initiates outbound voice calls, handles complex objection dialogues, and schedules qualified appointments directly into rep calendars.',
    icon: 'Bot',
    badge: 'Agentic Revenue',
    keyFeatures: [
      'Autonomous two-way natural language voice conversations',
      'Instant calendar booking integration (Calendly, Google)',
      'Lead scoring & qualification pipeline sync',
      'Multi-lingual support (English, French, Urdu, Spanish)'
    ],
    useCases: [
      'Automotive Dealership Inbound/Outbound Leads',
      'Healthcare & Wellness Appointment Booking',
      'E-commerce High-Ticket Inquiries'
    ],
    heroImage: ASSETS.images.virtualAssistant
  },
  {
    id: 'sop-monitoring',
    name: 'SOP Monitoring',
    tagline: 'Real-Time Computer Vision for Kitchen & Industrial Compliance.',
    description: 'Monitors existing camera streams via YOLOv8 computer vision models to detect hand hygiene, PPE, apron usage, and safety protocol compliance with sub-second alert triggers.',
    icon: 'Eye',
    badge: 'Vision Compliance',
    keyFeatures: [
      'YOLOv8 real-time object & pose detection',
      'Hand washing, mask, and glove compliance tracking',
      'Instant SMS/Telegram alerts for SOP violations',
      'Automated compliance reporting for health audits'
    ],
    useCases: [
      'Fast-Casual Restaurant & QSR Chains',
      'Food Processing & Industrial Packaging Plants',
      'Cleanroom & Pharmaceutical Facilities'
    ],
    heroImage: ASSETS.images.aqiDashboard
  },
  {
    id: 'inventory-forecasting',
    name: 'Inventory Forecasting',
    tagline: 'ML Demand Prediction Engine with Natural Language RAG Bot.',
    description: 'Uses historical sales, seasonal trends, and macro supply variables to forecast inventory requirements with 94%+ accuracy, supported by an interactive AI query assistant.',
    icon: 'PackageCheck',
    badge: 'Supply Chain ML',
    keyFeatures: [
      'LSTM & XGBoost predictive demand forecasting',
      'RAG chatbot for natural language inventory queries',
      'Automated purchase order trigger suggestions',
      'Multi-warehouse stock allocation optimization'
    ],
    useCases: [
      'Retail & E-commerce Multi-Store Brands',
      'Wholesale Distributors in US & Pakistan',
      'Manufacturing Raw Material Planning'
    ],
    demoVideo: ASSETS.videos.inventoryAi,
    heroImage: ASSETS.images.inventory1
  },
  {
    id: 'hrms',
    name: 'HRMS (IntelliGraph Powered)',
    tagline: 'Intelligent Human Resource Management Platform.',
    description: 'Next-generation HR operating system connecting personnel records, attendance, payroll, performance evaluations, and org-chart knowledge graphs.',
    icon: 'Users',
    badge: 'Enterprise HR',
    keyFeatures: [
      'Knowledge graph based organizational hierarchy',
      'Automated payroll calculation & tax compliance (US/PK)',
      'Leave management & biometric attendance sync',
      'AI performance review generation & goal tracking'
    ],
    useCases: [
      'Growing Technology Companies & Remote Teams',
      'Cross-border US-Pakistan Offshore Development Labs',
      'Mid-Market Enterprises'
    ],
    heroImage: ASSETS.images.workspace
  }
];

export const SERVICES: ServiceItem[] = [
  // Development
  {
    id: 'website-development',
    title: 'Website Development',
    category: 'development',
    shortDesc: 'Responsive, high-performance web experiences designed for maximum search visibility and conversions.',
    fullDesc: 'We craft bespoke web assets tailored to your brand identity, delivering lightning-fast load times, flawless mobile responsiveness, and clean SEO architecture.',
    whatWeBuild: 'Corporate websites, landing pages, interactive web portals, and content-managed platforms.',
    whatsIncluded: [
      'Custom UI/UX web design adhering to brand guidelines',
      'CMS integration (Headless, Custom, or WordPress)',
      'Search engine optimized semantic HTML markup',
      'Speed optimization (sub-second Core Web Vitals)',
      'Multi-language & regional geotargeting (US/PK)'
    ],
    technologies: ['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Laravel', 'Node.js'],
    ctaText: 'Build Your Website →',
    mediaUrl: ASSETS.videos.codeFlow,
    mediaType: 'video'
  },
  {
    id: 'web-app-development',
    title: 'Web App Development',
    category: 'development',
    shortDesc: 'Scalable, enterprise-grade SaaS applications built to handle complex business logic and millions of requests.',
    fullDesc: 'From multi-tenant cloud platforms to administrative command centers, we engineer resilient web apps with bulletproof security.',
    whatWeBuild: 'Enterprise SaaS platforms, admin dashboards, portal portals, real-time web suites.',
    whatsIncluded: [
      'API-first modular backend architecture',
      'Role-based access control (RBAC) & OAuth2',
      'Database optimization for heavy throughput',
      'Real-time WebSocket & event-driven sync'
    ],
    technologies: ['Python/Django', 'FastAPI', 'Node.js', 'React', 'PostgreSQL', 'MongoDB', 'AWS'],
    ctaText: 'Build Your Web App →',
    mediaUrl: ASSETS.images.realEstateHero,
    mediaType: 'image'
  },
  {
    id: 'marketplace-development',
    title: 'Marketplace Development',
    category: 'development',
    shortDesc: 'Multi-vendor marketplace platforms with intelligent buyer-supplier matchmaking and automated payouts.',
    fullDesc: 'Build thriving two-sided B2B or B2C commerce networks complete with automated escrow payments, commission rules, and inventory sync.',
    whatWeBuild: 'B2B wholesale exchanges, B2C service marketplaces, multi-vendor e-commerce platforms.',
    whatsIncluded: [
      'Vendor onboarding & verification portals',
      'Automated commission & split-payment handling',
      'AI-powered product/service matchmaking',
      'Real-time shipping & order status tracking'
    ],
    technologies: ['Laravel', 'React', 'Node.js', 'Stripe Connect', 'PayPal', 'PostgreSQL'],
    ctaText: 'Build Your Marketplace →',
    mediaUrl: ASSETS.images.foodAppShowcase,
    mediaType: 'image'
  },
  {
    id: 'pos-development',
    title: 'POS System Development',
    category: 'development',
    shortDesc: 'Modern integrated Point of Sale software engineered for retail, QSR, and service franchises.',
    fullDesc: 'Connect hardware barcode scanners, receipt printers, and payment terminals with cloud inventory state and analytics in real-time.',
    whatWeBuild: 'Cloud POS applications, retail checkout systems, restaurant kitchen display systems (KDS).',
    whatsIncluded: [
      'Offline-first offline transactional queue',
      'Hardware SDK integration (Printers, Scanners, Terminals)',
      'Multi-store inventory reconciliation',
      'Employee shift & commission tracking'
    ],
    technologies: ['React Native', 'Electron', 'Python/Django', 'PostgreSQL', 'Stripe Terminal'],
    ctaText: 'Build Your POS System →',
    mediaUrl: ASSETS.images.carWashShowcase,
    mediaType: 'image'
  },

  // AI & ML Services
  {
    id: 'chatbots-conversational-ai',
    title: 'Chatbots & Conversational AI',
    category: 'ai-ml',
    shortDesc: 'Context-aware chatbots and voice agents that automate customer service and sales across all touchpoints.',
    fullDesc: 'Deploy intelligent conversational agents that understand complex customer intent, remember context across sessions, and execute API actions.',
    whatWeBuild: 'Web support bots, WhatsApp marketing bots, voice response agents, CRM-integrated virtual reps.',
    whatsIncluded: [
      'Natural Language Understanding (NLU) & Sentiment Analysis',
      'Omnichannel deployment (Web, WhatsApp, Voice, Email)',
      'Human-in-the-loop fallback routing',
      'Custom Knowledge Base grounding'
    ],
    technologies: ['OpenAI', 'Gemini API', 'LangChain', 'Twilio', 'WhatsApp Cloud API', 'VAPI'],
    ctaText: 'Build Your AI Agent →',
    mediaUrl: ASSETS.videos.aiNeural,
    mediaType: 'video'
  },
  {
    id: 'rag-systems',
    title: 'RAG (Retrieval-Augmented Generation)',
    category: 'ai-ml',
    shortDesc: 'Enterprise RAG solutions connecting LLMs securely to your proprietary enterprise knowledge.',
    fullDesc: 'Eliminate LLM hallucinations by grounding generative AI responses directly in your company documents, databases, and policy manuals with verifiable source citations.',
    whatWeBuild: 'Enterprise knowledge bots, legal research engines, medical policy assistants.',
    whatsIncluded: [
      'Vector indexing & semantic chunking pipelines',
      'GraphRAG context augmentation via Neo4j',
      'Role-filtered enterprise document security',
      'Source-cited natural language answers'
    ],
    technologies: ['LangChain', 'LlamaIndex', 'Pinecone', 'Neo4j', 'Qdrant', 'OpenAI', 'Gemini'],
    ctaText: 'Build Your RAG System →',
    mediaUrl: ASSETS.images.nlpDev,
    mediaType: 'image'
  },
  {
    id: 'ai-frontdesk-assistant',
    title: 'AI Frontdesk Assistant',
    category: 'ai-ml',
    shortDesc: '24/7 AI receptionists that handle inbound phone calls, schedule appointments, and qualify callers.',
    fullDesc: 'Replace static IVR phone menus with a warm, natural human-sounding AI frontdesk assistant that speaks multiple languages and updates your calendar.',
    whatWeBuild: 'Inbound phone receptionists, clinic booking assistants, hotel concierge AI.',
    whatsIncluded: [
      'Sub-800ms full-duplex voice response latency',
      'Calendar scheduling sync (Google Workspace, Outlook)',
      'Multi-lingual language switching mid-call',
      'Automated caller qualification & CRM logging'
    ],
    technologies: ['Voice AI', 'Twilio', 'VAPI', 'Google Calendar API', 'Whisper STT'],
    ctaText: 'Deploy Your AI Frontdesk →',
    mediaUrl: ASSETS.images.virtualAssistant,
    mediaType: 'image'
  },
  {
    id: 'ai-calling-agent',
    title: 'AI Calling Agent',
    category: 'ai-ml',
    shortDesc: 'Outbound voice agents performing automated lead qualification, surveys, and follow-ups at scale.',
    fullDesc: 'Conduct thousands of personal outbound calls per hour while maintaining natural human tone, strict regulatory compliance, and warm transfers.',
    whatWeBuild: 'Outbound sales agents, appointment reminder bots, customer feedback pollers.',
    whatsIncluded: [
      'Intelligent speech detection & objection handling',
      'Warm transfer to live sales representatives',
      'TCPA compliance & regional calling windows',
      'Detailed call transcript & sentiment analytics'
    ],
    technologies: ['Twilio', 'VAPI', 'Whisper', 'WaveNet', 'FastAPI', 'PostgreSQL'],
    ctaText: 'Deploy AI Calling Agent →',
    mediaUrl: ASSETS.videos.aiNeural,
    mediaType: 'video'
  },
  {
    id: 'agentic-ai',
    title: 'Agentic AI Systems',
    category: 'ai-ml',
    shortDesc: 'Autonomous multi-agent systems that plan, execute, and adapt to achieve complex multi-step goals.',
    fullDesc: 'Move beyond passive AI chat to autonomous agentic workflows where specialized AI agents collaborate, call external APIs, check facts, and solve multi-tier problems.',
    whatWeBuild: 'Autonomous research agents, supply chain auto-replenish agents, software testing agents.',
    whatsIncluded: [
      'Multi-agent framework architecture (CrewAI, AutoGen)',
      'Goal decomposition & dynamic tool execution',
      'Human-in-the-loop validation checkpoints',
      'Self-correcting error recovery mechanisms'
    ],
    technologies: ['LangGraph', 'CrewAI', 'Python', 'FastAPI', 'Gemini 2.5', 'Docker'],
    ctaText: 'Build Agentic AI →',
    mediaUrl: ASSETS.images.apiIntegration,
    mediaType: 'image'
  },
  {
    id: 'computer-vision',
    title: 'Computer Vision & Camera Monitoring',
    category: 'ai-ml',
    shortDesc: 'Real-time video analytics turning ordinary CCTV streams into intelligent automated sensors.',
    fullDesc: 'Perform continuous automated inspection, security perimeter guarding, PPE verification, and activity recognition across existing RTSP camera feeds.',
    whatWeBuild: 'Safety compliance monitoring, perimeter intrusion detectors, retail heatmapping systems.',
    whatsIncluded: [
      'YOLOv8 custom object & pose detection training',
      'RTSP stream decoding & edge processing',
      'Real-time alert dispatching (SMS, Push, Email)',
      'Historical visual compliance dashboard'
    ],
    technologies: ['YOLOv8', 'OpenCV', 'PyTorch', 'FFmpeg', 'Docker', 'Python'],
    ctaText: 'Build Computer Vision →',
    mediaUrl: ASSETS.videos.criticalInfra,
    mediaType: 'video'
  },

  // Automation Services
  {
    id: 'crm-automation',
    title: 'CRM Automation',
    category: 'automation',
    shortDesc: 'Automate sales lead capture, pipeline updates, follow-up sequences, and customer history logging.',
    fullDesc: 'Connect Salesforce, HubSpot, or custom CRMs with all inbound touchpoints to ensure zero lead leakage and immediate follow-up response times.',
    whatWeBuild: 'Automated CRM lead routing, deal pipeline sync, customer journey triggers.',
    whatsIncluded: [
      'Lead enrichment from domain & email metadata',
      'Automated task creation for sales representatives',
      'Multi-channel follow-up drip execution',
      'Custom CRM dashboard reporting'
    ],
    technologies: ['HubSpot API', 'Salesforce API', 'n8n', 'Python', 'Zapier'],
    ctaText: 'Automate Your CRM →',
    mediaUrl: ASSETS.images.dataAnalytics,
    mediaType: 'image'
  },
  {
    id: 'lead-generation-automation',
    title: 'Lead Generation Automation',
    category: 'automation',
    shortDesc: 'Continuous multi-channel systems that discover, score, and engage ideal client profiles 24/7.',
    fullDesc: 'Automate your outbound sales pipeline from target company prospecting and verified email extraction to personalized outreach execution.',
    whatWeBuild: 'Automated prospecting engines, AI email sequence generators, lead scoring bots.',
    whatsIncluded: [
      'Ideal Client Profile (ICP) data scraping & verification',
      'Hyper-personalized AI email copy generation',
      'DMARC/SPF/DKIM email deliverability warm-up',
      'Positive reply detection & auto-booking'
    ],
    technologies: ['Python', 'Scrapy', 'OpenAI', 'SendGrid', 'LinkedIn API'],
    ctaText: 'Automate Lead Gen →',
    mediaUrl: ASSETS.images.smmHero,
    mediaType: 'image'
  },
  {
    id: 'workflow-automation',
    title: 'Business Workflow Automation',
    category: 'automation',
    shortDesc: 'Connect fragmented enterprise tools into unified, error-free automated operational pipelines.',
    fullDesc: 'Eliminate repetitive manual data entry, invoice processing, cross-departmental handoffs, and document generation.',
    whatWeBuild: 'End-to-end operational pipelines, automated invoice parsers, document generation workflows.',
    whatsIncluded: [
      'Process mapping & workflow auditing',
      'Custom n8n / Python orchestration middleware',
      'OCR document extraction & validation',
      'Real-time execution monitoring alerts'
    ],
    technologies: ['n8n', 'Python', 'FastAPI', 'Google Cloud Vision', 'Docker'],
    ctaText: 'Automate Workflows →',
    mediaUrl: ASSETS.images.analytics,
    mediaType: 'image'
  },

  // Marketing Services
  {
    id: 'seo-services',
    title: 'SEO (Search Engine Optimization)',
    category: 'marketing',
    shortDesc: 'Data-driven technical and content SEO strategies that secure top search rankings in US & PK markets.',
    fullDesc: 'Dominate organic search results with high-intent keyword strategies, technical site speed optimizations, schema markup, and authoritative backlink acquisition.',
    whatWeBuild: 'Technical SEO audits, regional content hubs, programmatic SEO landing page systems.',
    whatsIncluded: [
      'Full technical site speed & crawlability audit',
      'High-intent keyword research for USA & Pakistan audiences',
      'Schema.org structured data implementation',
      'Authority building & high-quality outreach'
    ],
    technologies: ['Ahrefs', 'SEMrush', 'Google Search Console', 'Schema.org', 'Next.js SEO'],
    ctaText: 'Improve Your SEO →',
    mediaUrl: ASSETS.images.seoHero,
    mediaType: 'image'
  },
  {
    id: 'social-media-marketing',
    title: 'Social Media Marketing & Paid Ads',
    category: 'marketing',
    shortDesc: 'Strategic social content creation, community management, and targeted Google & Meta ad campaigns.',
    fullDesc: 'Build brand authority and drive measurable ROI with targeted digital campaign strategies tailored for B2B tech and enterprise buyers.',
    whatWeBuild: 'Omnichannel social brand presence, Meta & Google PPC ad campaigns, B2B LinkedIn outreach.',
    whatsIncluded: [
      'Monthly visual & video content production calendar',
      'Targeted ad campaign structure & copy A/B testing',
      'Retargeting pixel setup & conversion API tracking',
      'Transparent weekly performance & ROI analytics'
    ],
    technologies: ['Meta Ads Manager', 'Google Ads API', 'LinkedIn Campaign Manager', 'Canva', 'Figma'],
    ctaText: 'Grow Your Brand →',
    mediaUrl: ASSETS.images.smmHero,
    mediaType: 'image'
  },

  // Global Talent
  {
    id: 'hire-a-developer',
    title: 'Global Talent Acquisition (Hire Developers)',
    category: 'talent',
    shortDesc: 'Scale your engineering bandwidth with top 1% senior software engineers & AI architects in US & Pakistan.',
    fullDesc: 'Access pre-vetted, elite full-stack, mobile, AI/ML, and DevOps engineers ready to integrate into your existing sprint workflows within 48 hours.',
    whatWeBuild: 'Dedicated engineering pods, staff augmentation, offshore R&D innovation centers in Pakistan.',
    whatsIncluded: [
      'Strict technical vetting & coding evaluation',
      'Overlapping US (EST/PST) & PK time zone working hours',
      'Direct communication via Slack, Teams & GitHub',
      'Zero recruitment overhead & flexible month-to-month contracts'
    ],
    technologies: ['React', 'Python', 'Node.js', 'PyTorch', 'AWS', 'Docker', 'Kubernetes'],
    ctaText: 'Hire Senior Developers →',
    mediaUrl: ASSETS.videos.globalTalent,
    mediaType: 'video'
  }
,
  {
    id: 'ai-marketing-agent',
    title: 'AI Marketing Agent',
    category: 'ai-ml',
    shortDesc: 'AI-powered marketing agents that automate lead generation, nurture campaigns, and customer engagement.',
    fullDesc: 'Deploy AI marketing agents that generate personalized content, orchestrate multi-channel outreach, and optimize conversions autonomously.',
    whatWeBuild: 'Automated marketing campaigns, content generators, social media AI.',
    whatsIncluded: [
      'Lead generation and qualification',
      'Personalized email and SMS campaigns',
      'Social media engagement',
      'Content creation assistance',
      'Conversion optimization',
      'Multi-channel orchestration'
    ],
    technologies: ['LLMs', 'Automation Workflows', 'CRM Integration', 'Email/SMS APIs'],
    ctaText: 'Deploy Your AI Marketing Agent',
    mediaUrl: ASSETS.images.analytics,
    mediaType: 'image'
  },
  {
    id: 'generative-ai',
    title: 'Generative AI',
    category: 'ai-ml',
    shortDesc: 'Custom generative AI solutions for content creation, design, ideation, and more.',
    fullDesc: 'Leverage the power of generative AI to create high-quality text, images, and code tailored to your brand.',
    whatWeBuild: 'Content generators, internal ideation tools, automated design systems.',
    whatsIncluded: [
      'Content generation (text, images, video)',
      'Code generation and assistance',
      'Marketing copy and campaign creation',
      'Product descriptions and SEO content',
      'Creative ideation and prototyping'
    ],
    technologies: ['OpenAI', 'Anthropic', 'Stable Diffusion', 'LLMs', 'Fine-Tuning'],
    ctaText: 'Leverage Generative AI',
    mediaUrl: ASSETS.images.nlpDev,
    mediaType: 'image'
  },
  {
    id: 'sop-compliance-automation',
    title: 'SOP Compliance Automation',
    category: 'ai-ml',
    shortDesc: 'Automated systems that monitor and enforce Standard Operating Procedures in real-time.',
    fullDesc: 'Transform operational compliance with computer vision and data analytics tracking every step of your standard operating procedures.',
    whatWeBuild: 'Safety monitoring systems, audit dashboards, automated alert pipelines.',
    whatsIncluded: [
      'SOP detection and monitoring',
      'Real-time compliance alerts',
      'Automated audit trails',
      'Performance dashboards',
      'Historical compliance reporting',
      'Integration with operational systems'
    ],
    technologies: ['YOLOv8', 'OpenCV', 'RTSP', 'Python', 'Dashboard Analytics'],
    ctaText: 'Automate SOP Compliance',
    mediaUrl: ASSETS.images.aqiDashboard,
    mediaType: 'image'
  },
  {
    id: 'machine-learning-analytics',
    title: 'Machine Learning & Data Analytics',
    category: 'ai-ml',
    shortDesc: 'Predictive models and analytics dashboards that turn your data into actionable intelligence.',
    fullDesc: 'Unlock hidden patterns and forecast future trends with custom machine learning models tailored to your industry.',
    whatWeBuild: 'Predictive forecasting tools, data visualization dashboards, anomaly detection models.',
    whatsIncluded: [
      'Predictive analytics and forecasting',
      'Real-time dashboard monitoring',
      'Anomaly detection',
      'Customer and operational insights',
      'Custom ML model development',
      'Data visualization and reporting'
    ],
    technologies: ['XGBoost', 'LSTM', 'Python', 'Tableau/PowerBI', 'Custom Dashboards'],
    ctaText: 'Build Your Analytics Solution',
    mediaUrl: ASSETS.images.dataAnalytics,
    mediaType: 'image'
  },
  {
    id: 'email-automation',
    title: 'Email Automation',
    category: 'automation',
    shortDesc: 'Intelligent email automation that engages prospects and customers at the right time with the right message.',
    fullDesc: 'Drive conversions with dynamic, personalized email workflows that trigger based on customer behavior and interactions.',
    whatWeBuild: 'Drip campaigns, newsletter pipelines, transactional email systems.',
    whatsIncluded: [
      'Automated campaign workflows',
      'Personalization at scale',
      'Behavioral trigger campaigns',
      'A/B testing and optimization',
      'Analytics and reporting'
    ],
    technologies: ['Email APIs', 'LLMs', 'Automation Workflows', 'CRM Integration'],
    ctaText: 'Automate Your Email',
    mediaUrl: ASSETS.images.seoHero,
    mediaType: 'image'
  },
  {
    id: 'response-automation',
    title: 'Response Automation',
    category: 'automation',
    shortDesc: 'Automated response systems that handle customer inquiries, support tickets, and feedback in real-time.',
    fullDesc: 'Ensure no customer query goes unanswered with intelligent response engines integrating with your helpdesk and CRM.',
    whatWeBuild: 'Support ticket bots, automated survey responders, real-time feedback loops.',
    whatsIncluded: [
      'Automated customer support',
      'Chat and ticket response automation',
      'Feedback and survey automation',
      'Escalation workflows',
      'Integration with helpdesk and CRM'
    ],
    technologies: ['LLMs', 'Chatbots', 'Email/SMS APIs', 'Helpdesk Integration'],
    ctaText: 'Automate Responses',
    mediaUrl: ASSETS.images.chatAppHero,
    mediaType: 'image'
  }

];

export const CASE_STUDIES: CaseStudy[] = [
  {
    id: 'ai-calling-french-auto',
    title: 'Native French Outbound AI Marketing Calling Agent',
    client: 'French Automotive Dealership Brand',
    industry: 'Automotive & Sales',
    challenge: 'Over 70% of digital lead inquiries were abandoned or uncontacted due to delayed rep response times outside standard business hours.',
    solution: 'Engineered a native French-speaking AI outbound voice agent with natural accent synthesis, automated TCPA compliance checks, and real-time CRM appointment sync.',
    result: '30% increase in sales test-drive conversions, with lead response time dropping from 4 hours down to under 60 seconds.',
    metrics: [
      { label: 'Conversion Boost', value: '+30%' },
      { label: 'Response Time', value: '< 60 Sec' },
      { label: 'Calls Conducted', value: '15,000+' }
    ],
    tags: ['AI Calling Agent', 'Voice AI', 'French Language', 'CRM Sync'],
    image: ASSETS.images.virtualAssistant
  },
  {
    id: 'healthcare-luganda-translator',
    title: 'Luganda ↔ English Ultra-Low Latency Speech Translator',
    client: 'East African Healthcare Network',
    industry: 'Healthcare & Telemedicine',
    challenge: 'Lack of real-time translation for low-resource native African dialects created life-threatening communication barriers between rural patients and English-speaking doctors.',
    solution: 'Fine-tuned OpenAI Whisper and neural acoustic models on low-resource Luganda speech corpora, achieving sub-850ms latency translation pipeline.',
    result: 'Enabled over 10,000 successful rural patient tele-consultations across 4 primary health networks.',
    metrics: [
      { label: 'Consultations', value: '10,000+' },
      { label: 'Latency', value: '< 850ms' },
      { label: 'Accuracy', value: '96.4%' }
    ],
    tags: ['Speech Translation', 'Whisper Fine-Tuning', 'Healthcare AI', 'NLP'],
    image: ASSETS.images.nlpDev
  },
  {
    id: 'federal-procurement-compliance',
    title: 'GraphRAG Autonomous Federal Procurement AI Compliance',
    client: 'Federal Defense & Civilian Government Agency',
    industry: 'GovTech & Federal Contracting',
    challenge: 'Reviewing complex contractor bids against thousand-page FAR / DFAR regulatory frameworks required 5 full days of manual attorney review per bid package.',
    solution: 'Deployed AMGOC IntelliGraph GraphRAG engine combining vector embeddings with knowledge graph relationships for hallucination-free legal compliance verification.',
    result: 'Cut bid review duration from 5 days to 15 minutes while maintaining 100% citation traceability back to regulation source clauses.',
    metrics: [
      { label: 'Review Time', value: '15 Mins' },
      { label: 'Accuracy', value: '100% Cited' },
      { label: 'Time Saved', value: '98%' }
    ],
    tags: ['GraphRAG', 'IntelliGraph', 'Government Defense', 'Legal AI'],
    image: ASSETS.images.dataAnalytics
  },
  {
    id: 'kitchen-sop-vision',
    title: 'YOLOv8 Computer Vision Kitchen SOP Compliance Monitor',
    client: 'Fast-Casual Restaurant Chain (50+ Locations)',
    industry: 'Hospitality & Retail Operations',
    challenge: 'Inconsistent employee hand-washing and PPE hygiene compliance created health code audit risks and operational variability.',
    solution: 'Installed YOLOv8 pose estimation and hand-tracking computer vision modules over existing kitchen CCTV cameras with instant floor manager alerts.',
    result: 'Achieved 97% sustained hygiene compliance across all 50 locations with zero health code violations during surprise audits.',
    metrics: [
      { label: 'Sustained Compliance', value: '97%' },
      { label: 'Audit Violations', value: '0' },
      { label: 'Locations Covered', value: '50+' }
    ],
    tags: ['Computer Vision', 'YOLOv8', 'SOP Monitoring', 'Edge Video'],
    image: ASSETS.images.aqiDashboard
  }
];

export const TEAM_MEMBERS: TeamMember[] = [
  {
    name: 'Rizwan Javed',
    role: 'Co-Founder & Chief Executive Officer',
    location: 'USA',
    bio: 'Visionary tech leader driving global AI adoption and corporate digital transformation across USA & Asian markets.',
    avatarUrl: ASSETS.images.teamRizwan
  },
  {
    name: 'Mubbashar Saddique',
    role: 'Co-Founder & Chief Technology Officer',
    location: 'Pakistan',
    bio: 'Pioneer in GraphRAG systems, autonomous agentic frameworks, and multi-tenant SaaS architecture.',
    avatarUrl: ASSETS.images.teamMubbashar
  },
  {
    name: 'Dr. Waheed',
    role: 'Head of AI Research & Computer Vision',
    location: 'Pakistan',
    bio: 'PhD in Machine Learning specializing in edge computer vision, YOLO gesture recognition, and predictive forecasting models.',
    avatarUrl: ASSETS.images.teamDrWaheed
  },
  {
    name: 'Usman',
    role: 'Director of Global Engineering & Delivery',
    location: 'USA',
    bio: 'Oversees enterprise delivery pods, client engagement in North America, and full-stack software excellence.',
    avatarUrl: ASSETS.images.teamUsman
  }
];

export const OLD_URL_REDIRECTS: RedirectRule[] = [
  { oldUrl: '/services/ai', newUrl: '/services/ai-services', reason: 'Consolidated AI & ML service hub' },
  { oldUrl: '/services/app-dev', newUrl: '/services/development-services', reason: 'Unified software engineering portal' },
  { oldUrl: '/solutions/critical-infrastructure', newUrl: '/solutions/industry/critical-infrastructure', reason: 'Structured industry sector route' },
  { oldUrl: '/solutions/geospatial', newUrl: '/solutions/industry/geospatial-ai', reason: 'Geospatial AI industry route' },
  { oldUrl: '/portfolio', newUrl: '/about', reason: 'Integrated case studies & company track record' },
  { oldUrl: '/contact-us', newUrl: '/contact', reason: 'Clean canonical contact URI' },
  { oldUrl: '/about-us', newUrl: '/about', reason: 'Canonical about route' },
  { oldUrl: '/blog', newUrl: '/insights', reason: 'Enhanced blog & industry insights hub' },
  { oldUrl: '/privacy', newUrl: '/privacy-policy', reason: 'Standard legal compliance URL' },
  { oldUrl: '/terms', newUrl: '/terms-of-service', reason: 'Standard terms URL' },
  { oldUrl: '/meetingsense', newUrl: '/solutions/meetingsense', reason: 'Direct product solution landing page' },
  { oldUrl: '/inventory-forecasting', newUrl: '/solutions/inventory-forecasting', reason: 'Direct ML inventory landing page' }
];

export const FAQS = [
  {
    q: 'Why choose AMGOC US LLC over traditional dev agencies?',
    a: 'Unlike traditional software shops that start from scratch, we have 10 production-ready SaaS products already built. We bring battle-tested architecture, deep AI expertise (GraphRAG, YOLOv8, Voice AI), and senior engineers working directly on your project across USA & Pakistan time zones.'
  },
  {
    q: 'How does AMGOC support clients in both the USA and Pakistan?',
    a: 'We operate dual innovation hubs: USA HQ in Delaware/Texas for client strategy, account management, and US compliance, and our Pakistan R&D center in Gulberg IV, Lahore for world-class, cost-efficient AI engineering. This dual model guarantees 24/7 delivery and maximum value.'
  },
  {
    q: 'Can we deploy your 10 SaaS products on our own private cloud infrastructure?',
    a: 'Yes. All 10 AMGOC SaaS products (IntelliGraph, Conversaigent, SchoolFlow360, Meeting Sense, etc.) offer white-label enterprise deployment options on AWS, GCP, Azure, or on-premise air-gapped servers.'
  },
  {
    q: 'How fast can we onboard dedicated developers for our project?',
    a: 'Through our Global Talent Acquisition service, pre-vetted senior software engineers and AI architects can start on your codebase within 48 to 72 hours.'
  }
];


export const TECH_STACK = [
  {
    category: 'AI & Machine Learning',
    technologies: ['PyTorch', 'TensorFlow', 'XGBoost', 'LSTM', 'LangChain', 'LlamaIndex', 'OpenAI', 'Anthropic', 'Hugging Face']
  },
  {
    category: 'Conversational AI',
    technologies: ['Whisper (Fine-Tuned)', 'WaveNet', 'Twilio', 'WhatsApp API', 'VAPI', 'Multi-Agent Architectures']
  },
  {
    category: 'Computer Vision',
    technologies: ['YOLOv8', 'OpenCV', 'Pose Estimation', 'RTSP Streaming', 'Deep Learning']
  },
  {
    category: 'Data & Knowledge',
    technologies: ['GraphRAG', 'Neo4j', 'Pinecone', 'Vector Databases', 'Knowledge Graphs']
  },
  {
    category: 'Backend',
    technologies: ['Python', 'Django', 'FastAPI', 'Node.js', 'Laravel', 'PostgreSQL', 'MongoDB']
  },
  {
    category: 'Frontend',
    technologies: ['React', 'Next.js', 'Vue.js', 'TypeScript', 'Tailwind CSS']
  },
  {
    category: 'Cloud & DevOps',
    technologies: ['AWS', 'Azure', 'GCP', 'Docker', 'Kubernetes', 'Terraform', 'GitHub Actions']
  }
];
